import { useEffect } from 'react';
import { useAuth } from '../context/AuthProvider';
import { hasNotificationPermission, requestFcmToken } from '../lib/firebase';
import { registerDevice } from '../api/notifications';

// Silently registers an FCM token with the backend when the user is signed in
// AND has already granted notification permission. It never prompts on its own
// (that should be an explicit opt-in), and is a complete no-op when Firebase is
// unconfigured or push isn't supported.
export function usePushRegistration() {
  const { isAuthenticated } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !hasNotificationPermission()) return undefined;
    let active = true;
    requestFcmToken()
      .then((token) => {
        if (active && token) registerDevice(token).catch(() => {});
      })
      .catch(() => {});
    return () => {
      active = false;
    };
  }, [isAuthenticated]);
}
